import { useCallback, useEffect, useState } from "react";

export const useExpandedFolders = (selectedPath: string | null) => {
  const [expandedFolders, setExpandedFolders] = useState<Set<string>>(new Set());

  const toggleFolder = useCallback((path: string) => {
    setExpandedFolders(previousFolders => {
      const nextFolders = new Set(previousFolders);
      if (nextFolders.has(path)) {
        nextFolders.delete(path);
      } else {
        nextFolders.add(path);
      }

      return nextFolders;
    });
  }, []);

  useEffect(() => {
    if (!selectedPath) {
      return;
    }

    const parts = selectedPath.split("/").slice(0, -1);
    if (parts.length === 0) {
      return;
    }

    setExpandedFolders(previousFolders => {
      const nextFolders = new Set(previousFolders);
      parts.forEach((_, index) => {
        nextFolders.add(parts.slice(0, index + 1).join("/"));
      });
      return nextFolders;
    });
  }, [selectedPath]);

  return { expandedFolders, setExpandedFolders, toggleFolder };
};
